import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@veeva/corgix/menu';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'emotion-theming';
import {
    myProfileMenuHeaderCSS,
    myProfileMenuHeaderClassOverridesCSS,
    userMenuOverrideCSS,
    userMenuSystemAccessIsLoggedCSS,
    userMenuSystemAccessIsLoggedMenuItemCSS,
    userMenuItemBlockCSS,
    userMenuItemLinkCSS,
    userMenuItemCSS,
    userMenuLogoutButtonCSS,
} from './styles/UserMenu.styles';
import AutoSubmitForm from '../../../../common/components/AutoSubmitForm';
import MenuDivider from '../../../../common/components/MenuDivider';

// Set padding on the links instead of the MenuItems so the entire MenuItems are clickable
const themeOverrides = { menuSpacing: 0, menuSpacingVariant1: 0 };

export default function UserMenu({ className, email, onMenuItemClick, profileImageUrl, admin }) {
    const [shouldLogout, setShouldLogout] = useState(false);

    return (
        <>
            {shouldLogout && <AutoSubmitForm targetURL="/ui/session/logout" />}
            <ThemeProvider theme={themeOverrides}>
                <Menu css={userMenuOverrideCSS} className={className}>
                    <MenuItem
                        value="header"
                        css={[userMenuItemCSS, myProfileMenuHeaderClassOverridesCSS]}
                    >
                        <div css={myProfileMenuHeaderCSS}>
                            <img
                                src={profileImageUrl}
                                alt="My Profile"
                                referrerPolicy="no-referrer"
                            />
                            <div>
                                <div>My Profile</div>
                                <div>{email}</div>
                            </div>
                        </div>
                    </MenuItem>
                    <MenuDivider />
                    <MenuItem
                        value="logs"
                        css={userMenuSystemAccessIsLoggedMenuItemCSS}
                        onClick={onMenuItemClick}
                    >
                        <Link to="/logs">
                            <div css={userMenuItemBlockCSS}>
                                System Log&nbsp;
                                <span css={userMenuSystemAccessIsLoggedCSS}>
                                    (All system access is logged)
                                </span>
                            </div>
                        </Link>
                    </MenuItem>
                    <MenuItem css={userMenuItemLinkCSS} value="help" onClick={onMenuItemClick}>
                        <Link to="/help">Help</Link>
                    </MenuItem>
                    {admin ? (
                        <MenuItem css={userMenuItemLinkCSS} value="admin" onClick={onMenuItemClick}>
                            <Link to="/admin">Admin Console</Link>
                        </MenuItem>
                    ) : null}
                    <MenuDivider />
                    <MenuItem value="logout">
                        <button
                            type="button"
                            onClick={() => setShouldLogout(true)}
                            css={userMenuLogoutButtonCSS}
                        >
                            Logout
                        </button>
                    </MenuItem>
                </Menu>
            </ThemeProvider>
        </>
    );
}

UserMenu.propTypes = {
    admin: PropTypes.bool,
    className: PropTypes.string,
    email: PropTypes.string,
    onMenuItemClick: PropTypes.func,
    profileImageUrl: PropTypes.string,
};
